export const HomeIcon = ({ className }: { className: string }) => {
  return (
    <svg
      className={`stroke-current ${className}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.125 8.281V17.5a.625.625 0 00.625.625H7.5v-5.313a.937.937 0 01.938-.937h3.124a.938.938 0 01.938.938v5.312h3.75a.624.624 0 00.625-.625V8.281"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.75 10l-8.325-7.969c-.195-.206-.652-.208-.85 0L1.25 10M15.625 6.992V2.5H13.75v2.695"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
